import { faker } from "@faker-js/faker";
import { Avatar, Box, Card, Chip, Divider, Grid, Stack, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import ThemedPaper from "../core/ThemedPaper";

const ProductCard = () => {
  return (
     <Card variant="outlined" sx={{ marginBottom: 1 }}>
      <Box sx={{ p: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography gutterBottom variant="h5" component="div">
            Toothbrush
          </Typography>
          <Typography gutterBottom variant="h6" component="div">
            $4.50
          </Typography>
        </Stack>
        <Typography color="text.secondary" variant="body2">
          Pinstriped cornflower blue cotton blouse takes you on a walk to the park or
          just down the hall.
        </Typography>
      </Box>
      <Divider />
      <Box sx={{ p: 2 }}>
        <Typography gutterBottom variant="body2">
          Select type
        </Typography>
        <Stack direction="row" spacing={1}>
          <Chip color="primary" label="Soft" size="small" />
          <Chip label="Medium" size="small" />
          <Chip label="Hard" size="small" />
        </Stack>
      </Box>
    </Card>
  );
};

export default function ProductDetail() {
  const { productId } = useParams();

  const fullName = faker.person.fullName({ sex: 'female'});
  const bio = faker.person.bio();

  return (
    <ThemedPaper elevation={2} sx={{
      // width: '100%',
      p: 2,
    }}>
      <ProductCard />
      <ProductCard />
      <ProductCard/>
    </ThemedPaper>
  );
}